import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Logo from '../components/Logo';
import { Button } from '../components/UI';

export default function NotFound() {
  return (
    <div style={{
      minHeight: '100vh', display: 'grid', placeItems: 'center',
      padding: 24, position: 'relative', zIndex: 1, textAlign: 'center',
    }}>
      <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <motion.div
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <Logo size={92} mark />
        </motion.div>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 62, color: 'var(--gold-400)', marginTop: 12 }}>404</h1>
        <p style={{ fontSize: 16, marginTop: 6 }}>This page could not be found</p>
        <p style={{ color: 'var(--text-mid)', fontSize: 13.5, marginTop: 8, maxWidth: 380 }}>
          The link may be out of date, or you may not have access to this area.
        </p>
        <Link to="/" style={{ display: 'inline-block', marginTop: 26 }}>
          <Button>Back to my portal</Button>
        </Link>
      </motion.div>
    </div>
  );
}
